import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetupItems } from '../models/setupItems';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { ArtistProductSummary, ArtistProductsSummaryRequest } from './artistproducts.service';
import { ArtistProduct } from '../models/artistproduct.model';

@Injectable({
  providedIn: 'root'
})
export class ProductRequestQueueService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getProductInQueue(galleryId: string | null = null , filters: ArtistProductsSummaryRequest): Observable<ProductRequest[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/fetch/';
    var url = environment.BASE_API_PATH + api + method + galleryId;
    return this.http.post<ProductRequest[]>(url, filters, httpOptions);
  }

  public getGalleryProductRequests(artistId: string | null = null, filters: ArtistProductsSummaryRequest): Observable<ProductRequest[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/gallery/product-requests/' + artistId;
    var url = environment.BASE_API_PATH + api + method;
    return this.http.post<ProductRequest[]>(url, filters, httpOptions);
  }

  public getProductHistory(): Observable<ProductRequestHistory[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/history';
    var url = environment.BASE_API_PATH + api + method;
    return this.http.get<ProductRequestHistory[]>(url, httpOptions);
  }
  public getAllProductRequests(): Observable<ProductRequest[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/fetch-request';
    var url = environment.BASE_API_PATH + api + method;
    return this.http.get<ProductRequest[]>(url, httpOptions);
  }

  public sendProductRequest(artistProductId: string, comment:ProductRequestCommentRequest |null = null): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = `/${artistProductId}/send`;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, comment, httpOptions);
  }

  public acceptProductRequest(requestData: ProductRequest): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/artist/acceptProductRequest';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, requestData, httpOptions);
  }

  public rejectProductRequest(productRequestId: string , comment:ProductRejectCommentRequest | null = null): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ProductRequestQueue';
    const method: string = '/' + productRequestId + '/reject';
    
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, comment, httpOptions);
  }
}

export class ProductRequest {
  Id!: string | null;
  GalleryId!: string;
  ArtistId!: string;
  ArtistProductId!: string;
  GalleryName!: string;
  BusinessName!: string;
  ResizedImageUrl?: string;
  ArtistName!: string;
  ArtistUserName!: string;
  IsProductAccepted!: boolean;
  IsProductRejected!: boolean;
  RequestedDate!: Date;
  RequestedBy!: string;
  ProductName!: string;
  PhoneNumber!: string;
  ProductImgUrl!: string;
  ArtistRevenue!: number;
  ArtistProductSummary!: ArtistProductSummary[]
  ShortDescription!: string;
  SerialNumber!: string;
  
 
}

export class ProductRejectCommentRequest {
  productRequestComment!: string;
  rejectProductRequestComment!: string;
}

export class ProductRequestCommentRequest{
  ProductRequestComment?: string;
}
export class ProductRequestHistory{
  Id!: string;
  ProductRequestQueueId!: string;
  Message!: string;
  ProductName!: string;
  ActionDate!: string;
  ArtistName!: string;
}